import { screenerCopyEn } from "../en-GB/screenerCopy";

export const screenerCopyEnUs = { ...screenerCopyEn };
